module.exports = __webpack_public_path__ + "static/media/game-character-sound_x3.e08a33a0.mp3";